module.exports = __webpack_public_path__ + "static/media/vg.b142c100.svg";